'use client';

import React from 'react';
import * as SubframeUtils from '../utils';

interface FilterChipRootProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode;
  active?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const FilterChipRoot = React.forwardRef<HTMLButtonElement, FilterChipRootProps>(
  function FilterChipRoot(
    { icon = null, active = false, children, className, ...otherProps },
    ref,
  ) {
    return (
      <button
        className={SubframeUtils.twClassNames(
          'text-caption font-caption flex h-6 items-center gap-1 rounded-full border border-transparent px-2 transition-all',
          active
            ? 'text-default-font border-neutral-200 bg-neutral-100 font-medium'
            : 'text-subtext-color hover:bg-neutral-50',
          className,
        )}
        ref={ref}
        {...otherProps}
      >
        {icon ? (
          <span className="text-caption flex items-center justify-center">{icon}</span>
        ) : null}
        {children}
      </button>
    );
  },
);

export const FilterChip = FilterChipRoot;
